import { common } from '@neo-one/client-common';
import { PublicKeyContractParameter } from '@neo-one/node-core';
import { StackItemBase } from './StackItemBase';
export class ECPointStackItem extends StackItemBase {
    constructor(value) {
        super();
        this.value = value;
    }
    asECPoint() {
        return this.value;
    }
    asBuffer() {
        return common.ecPointToBuffer(this.value);
    }
    toContractParameter(_seen = new Set()) {
        return new PublicKeyContractParameter(this.value);
    }
}

//# sourceMappingURL=ECPointStackItem.js.map
